import { Box } from "@mui/material";
import type { PokemonDefenceInterface } from "../../pokemon/pokemon";
import { hasPokemonStatus, setPokemonStatus } from "../../pokemon/pokemon";
import StatusAilmentSelect, { STATUS_AILMENT_OPTIONS, StatusAilmentKey } from "../../components/StatusAilmentSelect";

interface InputStatusProps {
  selectedPokemon: PokemonDefenceInterface;
  setSelectedPokemon: React.Dispatch<React.SetStateAction<PokemonDefenceInterface | null>>;
}

// 左側ポケモンの状態異常を簡易選択するための候補
const STATUS_OPTIONS: Array<{ key: StatusAilmentKey; label: string }> = STATUS_AILMENT_OPTIONS;

function InputStatus({ selectedPokemon, setSelectedPokemon }: InputStatusProps) {
  const selectedStatus = STATUS_OPTIONS.find((status) =>
    hasPokemonStatus(selectedPokemon?.other_setting, status.key),
  )?.key ?? 'none';

  const handleStatusChange = (status: StatusAilmentKey | 'none') => {
    setSelectedPokemon((prev) => {
      if (!prev) {
        return prev;
      }
      // 単一選択に統一するため、選択外の状態は解除する
      let nextSetting = prev.other_setting;
      STATUS_OPTIONS.forEach((option) => {
        nextSetting = setPokemonStatus(nextSetting, option.key, option.key === status);
      });
      return {
        ...prev,
        other_setting: nextSetting,
      };
    });
  };

  return (
    <Box>
      <StatusAilmentSelect value={selectedStatus} onChange={handleStatusChange} />
    </Box>
  );
}

export default InputStatus;
